module.exports = __webpack_public_path__ + "img/history.d9624f70.svg";